(function () {
    "use strict";
    angular
        .module('realmCommerceApp')
        .factory('loaderService', loaderService);

    function loaderService() {
        var service = {
            data: {isLoading: false},
            start: start,
            stop: stop,
            showLoader: showLoader
        };
        return service;

        function start() {
            service.data.isLoading = true;
        }

        function stop() {
            service.data.isLoading = false;
        }

        function showLoader() {
            return service.data.isLoading;
        }

    }

})();


// WEBPACK FOOTER //
// ./static/js/app/services/loader.service.js